import { combineReducers } from 'redux';
import freeONLGChannelSettingList from './freeONLGChannelSettingList';
import freeONLGChannelSettingListFetching from './freeONLGChannelSettingListFetching';

export default combineReducers({
  freeONLGChannelSettingList,
  freeONLGChannelSettingListFetching,
});
